"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("@emotion/react");

const classes = {
  separacion: theme => /*#__PURE__*/(0, _react.css)("width:94%;margin-bottom:", theme.spacing(2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:separacion;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRlcy9Gb3JtRGF0b3NGaXNjYWxlc1Rlc3Qvc3R5bGUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRzhCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRlcy9Gb3JtRGF0b3NGaXNjYWxlc1Rlc3Qvc3R5bGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IGNsYXNzZXMgPSB7XG4gICAgc2VwYXJhY2lvbjogKHRoZW1lKSA9PiBjc3NgXG4gICAgICAgIHdpZHRoOiA5NCU7XG4gICAgICAgIG1hcmdpbi1ib3R0b206ICR7dGhlbWUuc3BhY2luZygyKX07XG4gICAgYCxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzZXM7XG4iXX0= */")
};
var _default = classes;
exports.default = _default;